﻿{
  "registration": {
    "sectionTitle": "КОНТРОЛЕН ПУНКТ",
    "title": "Регистрация",
    "firstName": "Собствено име",
    "lastName": "Фамилия",
    "company": "Транспортна компания",
    "companyPlaceholder": "Въведете 3 букви за търсене...",
    "plate": "Регистрационен номер",
    "orderNumber": "Номер на поръчка",
    "photo": "Снимка на шофьора",
    "takePhoto": "Направете снимка",
    "chooseFile": "Изберете файл",
    "security": "Прочетох и приемам протокола за безопасност на обекта",
    "securitySub": "ЛПС задължително · Забранени зони · Макс. скорост 10 км/ч",
    "submit": "Потвърдете регистрацията",
    "success": "Регистрацията е завършена успешно",
    "qrInstruction": "Сканирайте този QR код за достъп до картата и услугите на обекта от вашия телефон или таблет.",
    "qrDone": "Регистрацията е завършена",
    "nextRegistration": "Следваща регистрация",
    "errorRequired": "Това поле е задължително",
    "errorSecurity": "Трябва да приемете протокола за безопасност",
    "phone": "Телефонен номер",
    "phonePlaceholder": "+359 88 123 4567",
    "tankCapacity": "Капацитет на цистерната (литри)",
    "tankCapacityPlaceholder": "Напр. 26000",
    "baffles": "Прегради",
    "bafflesYes": "Да",
    "bafflesNo": "Не",
    "tare": "Тара на МПС (кг)",
    "tarePlaceholder": "Напр. 14500",
    "washCertificate": "Сертификат за почистване",
    "washWashed": "Измита",
    "washNotWashed": "Неизмита",
    "adr": "Съответствие ADR",
    "adrCompliant": "Съответства",
    "adrNotCompliant": "Не съответства",
    "groupContact": "Контакт",
    "groupVehicle": "МПС и Цистерна",
    "groupCompliance": "Съответствие",
    "groupSecurity": "Безопасност",
    "securityProtocol": "Протокол за безопасност на обекта",
    "groupMedia": "Медия",
    "fieldOptional": "По избор",
    "fieldRequired": "Задължително",
    "wizardStepLabel": "Стъпка",
    "wizardStep1Title": "Каква операция извършвате?",
    "wizardStep1Subtitle": "Изберете типа на намесата на обекта",
    "wizardExpedition": "Експедиция",
    "wizardLivraison": "Доставка",
    "wizardStep2Title": "Номер на поръчка",
    "wizardOrderLabel": "Номер на поръчка",
    "wizardOrderHintExpedition": "Пример: AR… или 5…",
    "wizardOrderHintLivraison": "Пример: 85…",
    "wizardOrderError": "Невалиден формат за този тип операция",
    "wizardOrderUnknown": "Нямам / не знам номера на поръчката",
    "wizardOrderPlanned": "Намерена планирана поръчка — полетата са попълнени",
    "wizardValidate": "Потвърди",
    "wizardBack": "Назад",
    "wizardStep3Title": "Какъв тип превозно средство управлявате?",
    "wizardStep3Subtitle": "Изберете превозното средство",
    "wizardTank": "Цистерна",
    "wizardTrailer": "Ремарке",
    "wizardModalIso": "ISO цистерна?",
    "wizardModalContainer": "Контейнер?",
    "wizardYes": "ДА",
    "wizardNo": "НЕ",
    "chassisPlate": "Номер ISO",
    "containerPlate": "Номер контейнер",
    "tareIso": "Тара ISO (kg)",
    "tareContainer": "Тара контейнер (kg)",
    "pinTitle": "PIN код",
    "pinError": "Грешен код",
    "pinCancel": "Отказ",
    "capturePhoto": "Заснеми",
    "guardAccess": "Достъп охрана",
    "trailerPlate": "Табела ремарке"
  },
  "driver": {
    "title": "Добре дошли на обекта",
    "subtitle": "Моля, следвайте инструкциите на контролния пункт",
    "yourPosition": "Вашата позиция",
    "enableGps": "Активирайте местоположение",
    "gpsActive": "Местоположението е активно",
    "gpsError": "Местоположението е недостъпно",
    "gpsPermission": "Разрешете достъп до местоположение",
    "helpBtn": "Нуждая се от помощ",
    "helpSent": "Заявката за помощ е изпратена",
    "helpAlready": "Вашата заявка е получена",
    "sessionExpired": "Сесията приключи",
    "sessionExpiredMsg": "Сесията ви е изтекла. Благодарим за посещението.",
    "waitingMsg": "Моля, изчакайте, служител ще ви обслужи скоро",
    "estimatedPassage": "Очаквано време на преминаване",
    "instruction": "Указание",
    "instructionClose": "Затвори"
  },
  "incident": {
    "alertTitle": "ТРЕВОГА — ЕВАКУИРАЙТЕ СЕ СЕГА",
    "alertSubtitle": "Следвайте незабавно указанията на картата",
    "alertInstruction": "Отидете до най-близкото място за сбор",
    "safeNow": "Аз съм в безопасност",
    "normalMode": "Ситуацията се върна към нормалното",
    "evacuation": "Точка за евакуация",
    "assembly": "Място за сбор",
    "firstAid": "Първа помощ"
  },
  "messages": {
    "title": "Съобщение от оператора",
    "placeholder": "Напишете съобщение до шофьора...",
    "send": "Изпрати",
    "dictate": "Диктувай",
    "translatedTo": "Преведено на",
    "noMessages": "Няма изпратени съобщения",
    "reactionSent": "Реакцията е изпратена"
  }
}
